import React from 'react';
import { Routes, Route } from 'react-router-dom';

// pages
import Name from './Name';
import Address from './Address';
import Email from './Email';
import EmergencyContact from './EmergencyContact';

function Contact() {
  return (
    <Routes>
      <Route path="name" element={<Name />} />
      <Route path="address" element={<Address />} />
      <Route path="email" element={<Email />} />
      <Route path="emergency-contact" element={<EmergencyContact />} />
    </Routes>
  );
}

export default Contact;
